import React, { PropTypes } from 'react';

import Benefits from '../Benefits';
import ButtonLink from '../../../ButtonLink';

import { hideBelowLG } from '../../../../base-styles/mixins.module.css';
import { arrow, button, subtitle, title } from '../styles.module.css';

/**
 * Presentation component for Book Now with available tickets.
 */
const Available = ({
  bookingPartner, buttonLabel, organiser,
  permalink, priceLabel, source, titleLabel,
}) => (
  <div>
    <h2 className={title}>{titleLabel}</h2>
    <p className={subtitle}>{priceLabel}</p>
    <ButtonLink
      to={`${permalink}/tickets${source ? `#source=${source}` : ''}`}
      rel="nofollow"
      primary
      className={button}
    >
      {buttonLabel}
      <span className={arrow} />
    </ButtonLink>
    {bookingPartner && (
      <div className={hideBelowLG}>
        <Benefits organiser={organiser} />
      </div>
    )}
  </div>
);

Available.propTypes = {
  bookingPartner: PropTypes.shape(),
  buttonLabel: PropTypes.string.isRequired,
  organiser: PropTypes.shape(),
  permalink: PropTypes.string.isRequired,
  priceLabel: PropTypes.string.isRequired,
  source: PropTypes.string,
  titleLabel: PropTypes.string.isRequired,
};

Available.defaultProps = {
  bookingPartner: undefined,
  organiser: undefined,
  source: undefined,
};

export default Available;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/Available/index.jsx